// libs
import React from 'react';

// types
import { ScorecardFragment } from '../../graphql/fragments/generated/Scorecard';
// components
import ScorecardPreview from '../ScorecardPreview';

interface ScorecardPreviewModalProps {
  scorecard: ScorecardFragment | undefined;
  onClose: () => void;
  showBack?: boolean;
}

const ScorecardPreviewModal = (props: ScorecardPreviewModalProps) => {
  const { onClose, scorecard, showBack = false } = props;
  const { title, questions, skill } = scorecard!;

  return scorecard ? (
    <ScorecardPreview
      questions={questions}
      showBack={showBack}
      skillName={skill?.name}
      title={title}
      onClose={onClose}
    />
  ) : null;
};

export default React.memo(ScorecardPreviewModal);
